import { Backdrop } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import { StylesProvider } from "@material-ui/core/styles";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect, Route, useHistory } from "react-router-dom";

import { selector as authStoreSelector } from "../../store/AuthStore";
import {
  selector as dataGraphStoreSelector,
  fetchClear as fetchClearDataGraphStore,
} from "../../store/DataGraphStore";
import {
  fetchClear as fetchClearFileStore,
  selector as fileStoreSelector,
} from "../../store/FileStore";
import {
  fetchClear as fetchClearOfficeStore,
  fetchListOfficeInfos,
  selector as officeStoreSelector,
} from "../../store/OfficeStore";
import { selector as registerStoreSelector } from "../../store/RegisterStore";
import {
  fetchClear as fetchClearRemoteMaintenanceStore,
  selector as remoteMaintenanceStoreSelector,
} from "../../store/RemoteMaintenanceStore";
import {
  fetchClear as fetchClearReportStore,
  selector as reportStoreSelector,
} from "../../store/ReportStore";
import { ProgressView } from "../share";

import { filesDrawerItem } from "./DrawerItems";
import ErrorDialog from "./ErrorDialog";
import MenuBar from "./MenuBar";
import Page from "./Page";
import useStyles from "./useStyles";

/**
 * Baseコンポーネント.
 *
 * @return {object} コンポーネント
 */
function Base() {
  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  // path情報
  const history = useHistory();

  const {
    // AuthStoreエラー
    error: authStoreError,
  } = useSelector(authStoreSelector);

  const {
    // FileStoreエラー
    error: fileStoreError,
  } = useSelector(fileStoreSelector);

  const {
    // OfficeStoreエラー
    error: officeStoreError,
  } = useSelector(officeStoreSelector);

  const {
    // DataGraphStoreエラー
    error: dataGraphStoreError,
  } = useSelector(dataGraphStoreSelector);

  const {
    // ReportStoreエラー
    error: reportStoreError,
  } = useSelector(reportStoreSelector);

  const {
    // RemoteMaintenanceStoreエラー
    error: remoteMaintenanceStoreError,
  } = useSelector(remoteMaintenanceStoreSelector);

  const {
    // 読み込み中フラグ（true: 表示、false: 非表示）
    isLoading: isRegisterLoading,
  } = useSelector(registerStoreSelector);

  // 副作用
  React.useEffect(() => {
    dispatch(fetchListOfficeInfos());
  }, [dispatch]);

  // 副作用
  React.useEffect(
    () => () => {
      dispatch(fetchClearFileStore());
      dispatch(fetchClearOfficeStore());
      dispatch(fetchClearDataGraphStore());
      dispatch(fetchClearReportStore());
      dispatch(fetchClearRemoteMaintenanceStore());
      history.push("/");
    },
    [dispatch, history]
  );

  // エラーオブジェクト
  const errorObject =
    authStoreError ||
    officeStoreError ||
    fileStoreError ||
    remoteMaintenanceStoreError ||
    dataGraphStoreError ||
    reportStoreError ||
    {};

  return (
    <StylesProvider injectFirst>
      <div className={styles.root}>
        <Route
          path="/"
          exact
          render={() => <Redirect to={filesDrawerItem.path} />}
        />
        <CssBaseline />
        <MenuBar />
        <Page />
        <ErrorDialog errorObject={errorObject} />
        <Backdrop className={styles.backdrop} open={isRegisterLoading}>
          <ProgressView />
        </Backdrop>
      </div>
    </StylesProvider>
  );
}

export default Base;
